export class User {
  constructor(username, email, password) {
    this.username = username;
    this.email = email;
    this.password = password;
  }
}
export class CreateApplicant {
  constructor(Email, FirstNameEN,LastNameEN 
      ,BirthDate,NationalityId,NationID,GenderID) {
      
      this.Email = Email ;
      this.FirstNameEN = FirstNameEN ;
      this.LastNameEN = LastNameEN ; 
      this.BirthDate = BirthDate ;
      this.NationalityId = NationalityId ;
      this.NationID = NationID ;
      this.GenderID = GenderID ;
  }
}
